import { render, staticRenderFns } from "./HelpDetail.vue?vue&type=template&id=1193eaf6&"
import script from "./HelpDetail.vue?vue&type=script&lang=js&"
export * from "./HelpDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports